import "./NftStaking.scss"
import React, { useMemo } from "react"
import { Box } from "@mui/material"
import { NftDetails } from "./types"

import Text from "../Text"
import { NftInfo } from "./Nft"

interface NftInfoViewProps {
  dataList: NftDetails[]
}

const NftInfoView: React.FC<NftInfoViewProps> = ({ dataList }) => {
  const nftsListMapping = useMemo(() => {
    return dataList?.map((item) => {
      return <NftInfo key={item.id} id={item.id} imgUrl={item.imgUrl} />
    })
  }, [dataList])

  return dataList?.length > 0 ? (
    <Box>
      <Text>Please confirm your selected NFT</Text>
      <Box mt={3} className="wrapper">
        {nftsListMapping}
      </Box>
    </Box>
  ) : (
    <Text>
      You have unstake all your existing NFT, please be aware that your boost
      factor and rewards will be affected.
    </Text>
  )
}

export default NftInfoView
